import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { MatDateFnsModule } from '@angular/material-date-fns-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideTransloco } from '@jsverse/transloco';
import Aura from '@primeng/themes/aura';
import { es } from 'date-fns/locale';
import { providePrimeNG } from 'primeng/config';
import { environment } from '../environments/environment';
import { ApiModule } from './api/api.module';
import { routes } from './app.routes';
import { MatPaginatorSpanish } from './core/services/mat-paginator-spanish.service';
import { ActingAsInterceptor } from './interceptors/acting-as.interceptor';
import { authInterceptor } from './interceptors/auth.interceptor';
import { TranslocoHttpLoader } from './transloco-loader';

export const appConfig: ApplicationConfig = {
  providers: [

    // NOTE para tema de fechas en angular material:
    { provide: MAT_DATE_LOCALE, useValue: es },
    { provide: MAT_ICON_DEFAULT_OPTIONS, useValue: { fontSet: 'material-icons-outlined' } },
    { provide: MatPaginatorIntl, useClass: MatPaginatorSpanish },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
        hideRequiredMarker: true
      }
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),
    providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.dark-mode' } } }),
    provideRouter(routes,
      withViewTransitions({
        skipInitialTransition: true
      })
    ),
    // ActingAsInterceptor is class-based to ensure proper injection context
    { provide: HTTP_INTERCEPTORS, useClass: ActingAsInterceptor, multi: true },
    provideHttpClient(
      withInterceptors([authInterceptor]),
      withInterceptorsFromDi()
    ),
    // NOTE settup for environment.apiBaseUrl
    //replace generated ApiModule rootUrl with environment.apiBaseUrl
    importProvidersFrom(
      MatDateFnsModule,
      ApiModule.forRoot({
        rootUrl: environment.apiBaseUrl
      })),
    // NOTE transloco configuration
    provideTransloco({
      config: {
        availableLangs: ['es'],
        defaultLang: 'es',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode()
      },
      loader: TranslocoHttpLoader
    })
  ]
};
